export const common: any = {
  update: "UPDATE",
  create: "CREATE",
  createNew: "CREATE NEW",
  publish: "PUBLISH",
  saveDraft: "SAVE DRAFT",
  changeToDraft: "CHANGE TO DRAFT",
  add: "ADD",
  delete: "DELETE",
  clear: "CLEAR",
  embed: "EMBED",
  dismiss: "DISMISS",
  showMore: "SHOW MORE",
  research: "SEARCH AGAIN",
  closeMore: "CLOSE",
  cancel: "CANCEL",
  reset: "RESET",
  reserve: "BOOK",
  detail: "DETAIL",
  schedule: "SCHEDULE",
  showAll: "Show all",
  showLess: "Show less",
  logIn: "LOG IN",
  lineAddFriend: "LINE Add Friend",
  travelConsultationOnLine: "Travel Consultation on LINE",
  send: "SEND",
  showDetail: "Show detail",
  hideDetail: "Hide detail",
  select: "SELECT",
  search: "SEARCH",
  searchShort: "SEARCH",
  showFilter: "Show filter",
  hideFilter: "Hide filter",
  set: "SET",
  contact: "CONTACT",
  contactViaEmail: "Contact via Email",
  contactViaEmailMultiline: "Contact via\nEmail",
  contactViaLine: "Contact via LINE",
  contactViaLineMultiline: "Contact via\nLINE",
  changeConditions: "Change Conditions",
  filterBy: "Filter by",
  sortBy: "Sort by",
  showAllSales: "Show all sales",
};
